import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';
import { NewsService } from '../../services/news.service';
import { NewsDetailsModel } from '../../models/news-details.model';
import { HeaderStateService } from '../../../main/headers/services/header-state.service';
import { TranslocoService } from '@jsverse/transloco';


@Component({
    templateUrl: './news-details.component.html',
    styleUrl: './news-details.component.scss'
})
export class NewsDetailsComponent implements OnInit {
    newsId!: string;
    newsModel: NewsDetailsModel | null = null;

    constructor(
        private newsService: NewsService,
        private route: ActivatedRoute,
        private headerStateService: HeaderStateService,
        private translocoService: TranslocoService
    ) { }

    ngOnInit(): void {
        this.newsId = this.getNewsId();
        if (this.newsId) {
            this.fetchNewsDetails(this.newsId);
        }
    }

    private getNewsId(): string {
        return this.route.snapshot.paramMap.get('id') || '';
    }

    private fetchNewsDetails(newsId: string): void {
        this.newsService.getNewsDetails(newsId).subscribe({
            next: (news) => {
                this.newsModel = news;
                const fromDate = format(this.newsModel.publicationFrom, 'EEEE, dd. MMMM', { locale: de });

                this.headerStateService.setDetailHeader(
                    this.translocoService.translate('news.pageTitle'),
                    `${fromDate}`,
                    '/home',
                    ''
                );
            },
            error: (err) => {
                console.error('Error fetching news details:', err);
            }
        });
    }
}
